import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePermissions } from '../hooks/usePermissions';

const ProtectedRoute = ({
  children,
  permission,
  fallback = '/',
  showLoading = true,
  loadingFallback = null,
}) => {
  const { loading: authLoading } = useAuth();
  const { hasPermission, loading } = usePermissions();

  if ((authLoading || loading) && showLoading) {
    if (loadingFallback) return loadingFallback;
    return (
      <div className="min-h-screen bg-gray-100 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500 mx-auto" />
          <p className="mt-4 text-gray-600 dark:text-gray-400">Verificando permissões...</p>
        </div>
      </div>
    );
  }

  if (!hasPermission(permission)) {
    return <Navigate to={fallback} replace />;
  }

  return children;
};

export default ProtectedRoute;
